<template>

  <section class="panel" style="background: #444;">
    <div class="panel-header" style="background:#333; color:#fff; border-bottom:1px solid #555;">
      <span>Предпросмотр</span>
      <span id="slide-count" style="font-weight:400; font-size:12px; opacity:0.7;"></span>
    </div>
    <div class="panel-content preview-container" id="preview-container">
      <div class="slide-page" v-if="images.length || fields.length">

        <div class="preview-photo-frame" v-for="image in images">
          <img :src="image.value" alt="Photo">
        </div>
        <div class="dj-item" v-for="field in fields">
          <div class="dj-label">{{ convertName(field.key) }}

            <template v-if="field.flags">
              <span v-for="flag in field.flags.value" class="badge"
                    :style="{backgroundColor: flag.color.value + '20', color: flag.color.value, borderColor: flag.color.value}">{{
                  flag.name.value
                }}</span>
            </template>
          </div>

          <div class="dj-nested" v-if="Array.isArray(field.value)">
            <template v-if="field.fields">
              <table>
                <thead>
                <tr>
                  <th class="dj-label" v-for="th in field.fields">{{ th }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="value in field.value.filter(x=>x.select)">
                  <td class="dj-value" v-for="td in value.value">
                    <template v-if="isFlag(td)">
                      <span v-for="flag in isFlag(td)" class="badge"
                            :style="{backgroundColor: flag.color + '20', color: flag.color, borderColor: flag.color}">{{
                          flag.name
                        }}</span>
                    </template>
                    <template v-else>{{ td }}</template>
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
            <template v-else>
              <div class="dj-nested-item" v-for="value in field.value.filter(x=>x.select)"><span>{{
                  value.value
                }}</span></div>
            </template>
          </div>
          <div class="dj-value" v-else>
            <template v-if="field.flags">{{field.value.value}}</template>
            <template v-else>{{ field.value }}</template>
            </div>
        </div>

      </div>
      <div style="color:#aaa; margin-top:80px;" v-else>Выберите строки слева</div>
    </div>
  </section>


</template>

<script>

export default {
  name: 'PdfPreview',
  props: {
    data: {type: Array, default: []},
  },
  data() {
    return {}
  },
  computed: {
    images() {
      let result = []
      const data = this.data ? this.data.map(x => x.json_data).flat() : [];
      data.forEach(val => {
        Object.keys(val).forEach(key => {
          if (val[key]?.select && key === 'image') result.push({...val[key], key: key})
        })
      })
      return result
    },
    fields() {
      let result = []
      const data = this.data ? this.data.map(x => x.json_data).flat() : [];
      data.forEach(val => {
        Object.keys(val).forEach(key => {
          if (val[key]?.select && key !== 'image') result.push({...val[key], key: key})
        })
      })
      return result
    }
  },
  mounted: function () {


  },
  methods: {
    isFlag(val){
      if (Array.isArray(val)) return val
      try {
        if (Array.isArray(JSON.parse(val))) return JSON.parse(val)
      }
      catch (e){
        return false
      }
    },
    convertName(name) {
      name = name.replaceAll('_', " ")
      return String(name).charAt(0).toUpperCase() + String(name).slice(1);
    }
  }
}

</script>

<style scoped lang="scss">

.panel {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

.panel-header {
  padding: 15px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-light);
  font-weight: 600;
  font-size: 15px;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-content {
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}

.preview-container {
  background: #555;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.slide-page {
  width: 100%;
  max-width: 600px;
  min-height: 500px;
  background: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  padding: 30px;
  box-sizing: border-box;
  position: relative;
  height: 520px;
}

.slide-num-badge {
  position: absolute;
  top: 10px;
  right: -30px;
  background: #333;
  color: #fff;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 3px;
}

.preview-photo-frame {
  float: left;
  width: 80px;
  height: 100px;
  border: 2px solid #0099cc;
  border-radius: 4px;
  margin: 0 15px 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  overflow: hidden;
}

.preview-photo-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dj-header {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 2px solid #0099cc;
  margin-bottom: 12px;
  padding-bottom: 5px;
  color: #000;
}

.dj-item {
  margin-bottom: 10px;
  padding-bottom: 0;
  border-bottom: 1px dotted #eee;
}

.dj-label {
  color: #666;
  font-weight: bold;
  font-size: 10px;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.dj-value {
  color: #000;
  font-size: 12px;
}

.dj-nested {
  margin-left: 10px;
  padding-left: 10px;
  //border-left: 2px solid #e0e0e0;

  table {
    td, th {
      padding: 1px 5px;
    }
  }
}

.dj-nested-item {
  padding: 4px 0;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 8px;
}

</style>
